<template>
    <KTeaserCard
        :as="NuxtLink"
        :to="`/${item.full_slug}`"
        :text="item.content.subtitle"
        variant="editorial"
        class="featured-article-card"
        @click="capture('related_article_clicked', {
            placement: 'recent-articles',
            target_slug: item.full_slug,
        })"
    >
        <template #media>
            <KFrame ratio="16 / 9">
                <NuxtImg
                    :src="item.content.image.filename"
                    :alt="item.content.image.alt"
                    width="712"
                    height="400"
                    fit="cover"
                    format="auto"
                    loading="lazy"
                    sizes="xs:100vw sm:100vw md:433px lg:330px xl:300px"
                />
            </KFrame>
        </template>
        <template #title>
            <span v-html="renderHighlightedText(item.content.title)" />
        </template>
    </KTeaserCard>
</template>

<script setup>
import { KFrame, KTeaserCard } from '@vemedia/karibu'
import { resolveComponent } from 'vue'
import renderHighlightedText from '~/helpers/renderHighlightedText'
import '~/components/featured-articles/featured-article-card.scss'

defineProps({
    item: {
        type: Object,
        required: true,
    },
})

const NuxtLink = resolveComponent('NuxtLink')

const { capture } = useTracking()
</script>
